module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"slice-document-download":"Télécharger"},"en":{"slice-document-download":"Download"}}')
  delete Component.options._Ctor
}
